export default __webpack_public_path__ + "static/media/success_alert.e82be492.svg";